import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Col, Row, Menu, Layout, Dropdown, Icon } from "antd";
import { Auth } from "aws-amplify";
import { sessionActions } from 'redux/modules/session';

const { Header } = Layout;

const AppHeader = ({ stores, user, currentStoreId, currentPath, selectStore }) => {
  const store = stores.find(s => s.storeId === currentStoreId);
  return (
    <Header>
      <Row>
        <Col span={2}>
          <div className="header-logo">FBQ</div>
        </Col>
        <Col span={18}>
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={[currentPath]}
            style={{ lineHeight: "64px" }}
          >
            <Menu.Item key="/">
              <Link to="/">Home</Link>
            </Menu.Item>
            <Menu.Item key="orders">
              <Link to="/orders">Etsy Orders</Link>
            </Menu.Item>
            <Menu.Item key="bulk-orders">
              <Link to="/bulk-orders">FBQ Orders</Link>
            </Menu.Item>
            <Menu.Item key="mappings">
              <Link to="/mappings">Mappings</Link>
            </Menu.Item>
            <Menu.Item key="listings">
              <Link to="/listings">Store Listings</Link>
            </Menu.Item>
            <Menu.Item key="settings">
              <Link to="/settings/stores">My Stores</Link>
            </Menu.Item>
            <Menu.Item key="help">
              <Link to="/help">Help</Link>
            </Menu.Item>
          </Menu>
        </Col>
        <Col span={4} className="text-right">
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu onClick={selectStore}>
                {stores
                  .filter(i => i.storeId !== currentStoreId)
                  .map(i => (
                    <Menu.Item key={i.storeId}>
                      <Icon type="shop" />
                      <a>{i.name}</a>
                    </Menu.Item>
                  ))}
                <Menu.Item key="profile">
                  <Link to="/settings">
                    <Icon type="user" /> Profile
                  </Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="signout" onClick={() => Auth.signOut()}>
                  Sign out
                </Menu.Item>
              </Menu>
            }
          >
            <a style={{ color: "white" }}>
              {store ? store.name : user.businessName || 'Unknown business'} <Icon type="down" />
            </a>
          </Dropdown>
        </Col>
      </Row>
    </Header>
  );
};

const mapDispatchToProps = dispatch => ({
  selectStore: item => {
    if (item.key !== 'profile') {
      dispatch(sessionActions.selectStore(item.key));
    }
  }
});

export default connect(
  state => state.session,
  mapDispatchToProps
)(AppHeader);
